/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// components
import Btn from '../Btn';

// helpers
import { i18n } from '../../lib/Utils';

const StopoverPropTypes = {
  icon: PropTypes.string, // Type of icon to display beside the address
  address: PropTypes.string.isRequired, // Address of the stopover
};

const StopoverDefaultProps = {
  icon: 'circle-o',
};

// eslint-disable-next-line arrow-parens
const Stopover = props => {
  const { icon, address } = props;

  return (
    <li className="stopover">
      <div className="directions__icons">
        <i className={classNames(`tsla-icon-${icon}`)} />
      </div>
      <div className="directions__details">
        <address>{address}</address>
      </div>
    </li>
  );
};

Stopover.propTypes = StopoverPropTypes;

Stopover.defaultProps = StopoverDefaultProps;

const ChargerPropTypes = {
  icon: PropTypes.string, // Type of icon to display beside the charger title
  title: PropTypes.string.isRequired, // Title of the charger
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired, // How long the user will need to charge their space craft
  label: PropTypes.string.isRequired, // charger charge duration
  handleClick: PropTypes.func.isRequired, // Method to invoke when charger is clicked
  type: PropTypes.string.isRequired, // Type of charger (super|destination)
};

const ChargerDefaultProps = {
  icon: 'supercharger',
};

// eslint-disable-next-line arrow-parens
const Charger = props => {
  // eslint-disable-next-line object-curly-newline
  const { title, duration, label, icon, handleClick, type } = props;

  return (
    <li className="plot">
      <div className="directions__icons">
        <i className={classNames(`tsla-icon_map--${icon}`)} />
      </div>
      <div
        role="button"
        tabIndex="0"
        onClick={e => handleClick(e)}
        className="directions__listener"
      >
        <div className="directions__details">
          <address className={type}>{title}</address>
          <span>
            {i18n(label, { DURATION: duration })}
            <i className="tsla-icon-angle_right" />
          </span>
        </div>
      </div>
    </li>
  );
};

Charger.propTypes = ChargerPropTypes;

Charger.defaultProps = ChargerDefaultProps;

const DestinationPropTypes = {
  address: PropTypes.string.isRequired, // Address of the destination
  hours: PropTypes.number.isRequired, // Estimated trip duration in hours
  minutes: PropTypes.number.isRequired, // Estimated trip duration in minutes
  distance: PropTypes.string.isRequired, // Trip distance
  handleClick: PropTypes.func.isRequired, // Method to pass to destination charger button
  buttonText: PropTypes.string.isRequired, // Destination charger button label
  durationLabel: PropTypes.string.isRequired, // Label for "Duration" of trip
  isDestinationChargers: PropTypes.bool.isRequired, // if the charger is a destination charger
};

const DestinationDefaultProps = {};

// eslint-disable-next-line arrow-parens
const Destination = props => {
  const {
    address,
    hours,
    minutes,
    distance,
    handleClick,
    buttonText,
    durationLabel,
    isDestinationChargers,
  } = props;

  return (
    <li className="plot plot--destination">
      <div className="directions__icons directions__icons--last-child">
        <i className="tsla-icon_map--pin" />
      </div>
      <div className="directions__details directions__details--no-border">
        <address>
          <div>{address}</div>
          <div className="arrival">
            <strong>
              {i18n(durationLabel, {
                HOURS: hours,
                MINUTES: minutes,
                FORMATTED_DISTANCE: distance,
              })}
            </strong>
          </div>
          {isDestinationChargers && (
            <Btn styles="directions__btn" handleClick={handleClick}>
              {buttonText}
            </Btn>
          )}
        </address>
      </div>
    </li>
  );
};

Destination.propTypes = DestinationPropTypes;

Destination.defaultProps = DestinationDefaultProps;

export { Stopover, Charger, Destination };
